import React from "react";

function CommercialIcon(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="#262626"
        d="M18.75 16.25h-.625V5.625A.625.625 0 0017.5 5h-3.125V3.125a.625.625 0 00-.625-.625h-7.5a.625.625 0 00-.625.625V7.5H2.5a.625.625 0 00-.625.625v8.125H1.25a.625.625 0 100 1.25h17.5a.624.624 0 100-1.25zm-12.5-2.5H5a.625.625 0 110-1.25h1.25a.625.625 0 110 1.25zm0-2.5H5A.625.625 0 115 10h1.25a.625.625 0 110 1.25zm5 5h-2.5v-3.125h2.5v3.125zm-.625-5h-1.25a.625.625 0 110-1.25h1.25a.624.624 0 110 1.25zm0-2.5h-1.25a.625.625 0 010-1.25h1.25a.625.625 0 110 1.25zm0-2.5h-1.25a.625.625 0 010-1.25h1.25a.625.625 0 110 1.25zM15 13.75h-1.25a.624.624 0 110-1.25H15a.624.624 0 110 1.25zm0-2.5h-1.25a.624.624 0 110-1.25H15a.624.624 0 110 1.25zm0-2.5h-1.25a.625.625 0 110-1.25H15a.625.625 0 110 1.25z"
      ></path>
    </svg>
  );
}

export default CommercialIcon;
